var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-222.000000, -246.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8 C0,9.00414753 0.814022408,9.81816994 1.81816994,9.81816994 C2.82231747,9.81816994 3.63633987,9.00414753 3.63633987,8 C3.63633987,6.99585247 2.82231747,6.18183006 1.81816994,6.18183006 C0.814022408,6.18183006 0,6.99585247 0,8 Z M6.18183006,8 C6.18183006,8.64956956 6.52837128,9.2497966 7.09091502,9.57458139 C7.65345876,9.89936617 8.34654124,9.89936617 8.90908498,9.57458139 C9.47162872,9.2497966 9.81816994,8.64956956 9.81816994,8 C9.81816994,6.99585247 9.00414753,6.18183006 8,6.18183006 C6.99585247,6.18183006 6.18183006,6.99585247 6.18183006,8 L6.18183006,8 Z M12.3636601,8 C12.3636601,9.00414753 13.1776825,9.81816994 14.1818301,9.81816994 C15.1859776,9.81816994 16,9.00414753 16,8 C16,6.99585247 15.1859776,6.18183006 14.1818301,6.18183006 C13.1776825,6.18183006 12.3636601,6.99585247 12.3636601,8 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.307192021df9d35a790016d2091cabae.svg";
export { ForwardRef as ReactComponent };